const tips = [
  {
    icon: "ri-shield-check-line",
    title: "Verify All Links",
    description: "Always double-check that you are on the official Vigorbuy spreadsheet website before entering any personal information or making purchases.",
  },
  {
    icon: "ri-lock-password-line",
    title: "Protect Personal Info",
    description: "Never share sensitive personal data through unverified channels. The Vigorbuy spreadsheet community recommends using secure payment methods only.",
  },
  {
    icon: "ri-alert-line",
    title: "Avoid Fake Websites",
    description: "Watch out for copycat sites impersonating the Vigorbuy spreadsheet. Bookmark the official URL and access it directly to stay safe.",
  },
  {
    icon: "ri-file-search-line",
    title: "Check Product Details",
    description: "Review QC photos, size charts, and material descriptions carefully. Compare multiple listings within the Vigorbuy spreadsheet before buying.",
  },
];

export default function SafetySection() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/70 text-accent-700 text-xs md:text-sm font-medium mb-4">
            <i className="ri-shield-flash-line"></i>
            <span className="whitespace-nowrap">Safety Center</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            Shop Smart with Our{" "}
            <span className="text-accent-500">Safety Guidelines</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            Your security matters. Follow these essential safety practices when using the Vigorbuy spreadsheet to ensure a secure and satisfying shopping experience.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {tips.map((tip) => (
            <div
              key={tip.title}
              className="flex gap-4 p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-accent-200/60 transition-all duration-300"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100/70 text-accent-600 flex-shrink-0">
                <i className={`${tip.icon} text-lg`}></i>
              </div>
              <div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1.5">{tip.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{tip.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}